/** @format */

import {validate} from 'email-validator';
import * as yup from 'yup';

const MIN_PHONE_LENGTH = 10;
const MAX_PHONE_LENGTH = 16;

export const validationSchema = yup.object({
  desiredDate: yup.date().required().nullable(),
  desiredTime: yup.string().required(),
  phone: yup
    .string()
    .trim()
    .min(MIN_PHONE_LENGTH, 'Введите корректный номер телефона')
    .max(MAX_PHONE_LENGTH, 'Введите корректный номер телефона')
    .matches(/^[+\d\s()-]+$/, 'Введите корректный номер телефона')
    .required('Обязательное поле'),
  email: yup
    .string()
    .trim()
    .required('Обязательное поле')
    .test('is-valid-email', 'Введен некорректный email-адрес', value =>
      value ? validate(value) : true,
    ),
});
